export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "enginePress.worker.98ce09c73d262968bcfc-enginePress.worker.worker.js");
}
